import { CustomModal } from "components/modals/ModalBox";
import { useEffect, useRef, useState } from "react";
import { toastMessage } from "utils/toastMessage";
import { addScrapeProductApi } from "services/product";
import Select from "react-select";
import { color } from "@mui/system";
import { useNavigate } from "react-router-dom";
import {
  masterBrandListApi,
  masterClothingCategoriesListApi,
  masterColorApi,
  masterSizeApi,
} from "services/master";
import { Star } from "utils/text";
import {
  bodyShapeArray,
  downplayArray,
  heightArray,
  occasionArray,
  paletteOptions,
  styleIdentityArray,
} from "utils/staticData";
import { MultiSelect } from "react-multi-select-component";
import Form from "./Form";
export const AddModel = ({
  setAddModal,
  addModal,
  debouncedValue,
  setErrors,
  selectedProducts,
  errors,
}) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    heightInchValue: [],
    bodyShape: [],
    bodyShapeValue: [],
    styleIdentity: [],
    styleIdentityValue: [],
    brand: "",
    flauntParts: [],
    flauntPartsValue: [],
    downplayParts: [],
    color: {},
    downplayPartsValue: [],
  });

  const [occasionName, setOccasionName] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const [availableSizes, setAvailableSizes] = useState([]);

  const [paletteName, setPaletteName] = useState([]);
  const [buttonLoaders, setButtonLoaders] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState({
    height: [],
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
    occasionName: [],
    availableSizes: [],
    category: "",
    brand: "",
    colorName: "",
  });

  const handleflauntParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      flauntParts: selectedOptions.map((option) => option.value),
      flauntPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, flauntPartsValue: null }));
  };
  const buttonRef = useRef();
  const handledownplayParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      downplayParts: selectedOptions.map((option) => option.value),
      downplayPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, downplayPartsValue: null }));
  };

  const handleStyleIdentity = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      styleIdentity: selectedOptions.map((option) => option.value),
      styleIdentityValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, styleIdentityValue: null }));
  };

  const handleSizeChange = (selectedOptions) => {
    setAvailableSizes(selectedOptions.map((option) => option.value));
    // setErrors((prevData) => ({ ...prevData, availableSizes: null }));
  };

  const handleOccasionChange = (selectedOptions) => {
    setOccasionName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, occasionName: null }));
  };

  const handleCategoryChange = (selectedOptions) => {
    setCategoryName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, categoryName: null }));
  };

  const handleHeight = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      heightInch: selectedOptions.map((option) => option.value),
      heightInchValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, heightInchValue: null }));
  };

  const handlePaletteChange = (selectedOptions) => {
    setPaletteName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, paletteName: null }));
  };

  const handleBodyShape = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      bodyShape: selectedOptions.map((option) => option.value),
      bodyShapeValue: selectedOptions,
    }));
    // setErrors((prevData) => ({ ...prevData, bodyShapeValue: null }));
  };
  const validateForm = () => {
    const newErrors = {};

    if (selectedOptions?.height?.length === 0)
      newErrors.height = "Height is required";
    if (selectedOptions?.paletteName?.length === 0)
      newErrors.paletteName = "Palette Name is required";

    // if (selectedOptions?.styleIdentity?.length === 0)
    //   newErrors.styleIdentity = "style identity is required";

    if (selectedOptions?.flauntParts?.length === 0)
      newErrors.flauntParts = "Flaunt parts is required";
    if (selectedOptions?.downplayParts?.length === 0)
      newErrors.downplayParts = "Downplay parts is required";
    if (selectedOptions?.occasionName?.length === 0)
      newErrors.occasionName = "Occasion name is required";
    if (selectedOptions?.category?.length === 0)
      newErrors.category = "Category name is required";
    // if (selectedOptions?.brand?.length === 0)
    //   newErrors.brand = "Brand name is required";
    if (selectedOptions?.colorName?.length === 0)
      newErrors.colorName = "color name is required";

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const handleAddToStock = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setButtonLoaders(true);
    try {
      // let payLoad = {
      //   paletteName: paletteName,
      //   occasion: occasionName,
      //   categoryId: formData.category,
      //   color: formData.color,
      //   brandId: formData.brand,
      //   bodyShape: formData.bodyShape,
      //   styleIdentity: formData.styleIdentity,
      //   flauntParts: formData.flauntParts,
      //   sizes: availableSizes,
      //   downplayParts: formData.downplayParts,
      //   height: formData.heightInch,
      //   scrapeUrl: debouncedValue,
      //   products: selectedProducts,
      // };
      let payLoad = {
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        occasion: selectedOptions.occasionName?.map((item) => item.value),
        categoryId: selectedOptions.category,
        color: selectedOptions.colorName,
        brandId: selectedOptions.brand,
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        height: selectedOptions.height?.map((item) => item.value),
        sizes: selectedOptions.availableSizes?.map((item) => item.value),
        scrapeUrl: debouncedValue,
        products: selectedProducts,
      };

      const res = await addScrapeProductApi(payLoad);
      if (res?.data?.status === 200) {
        setAddModal(false);
        setFormData({
          heightInchValue: [],
          bodyShape: [],
          bodyShapeValue: [],
          styleIdentity: [],
          flauntParts: [],
          flauntPartsValue: [],
          downplayParts: [],
          downplayPartsValue: [],
        });
        setErrors({});
        setPaletteName([]);
        setOccasionName([]);
        toastMessage(res?.data?.message, "success", "addProduct");
        navigate("/product-management/scrape");
        // scrapeProductListHandler()
        setButtonLoaders(false);
      }
    } catch (e) {
      toastMessage(e.message, "error", "addProduct");
    } finally {
      setButtonLoaders(false);
    }
  };

  //--------------modal-close----------------
  const handleModalClose = () => {
    setAddModal(false);
    setSelectedOptions({
      height: [],
      paletteName: [],
      bodyShape: [],
      styleIdentity: [],
      flauntParts: [],
      downplayParts: [],
      occasionName: [],
      availableSizes: [],
      category: "",
      brand: "",
      colorName: "",
    });
    // setPaletteName([]);
    // setOccasionName([]);
    setErrors({});
  };
  return (
    <>
      <CustomModal
        show={addModal}
        handleClose={handleModalClose}
        className={"add_model"}
        size={"lg"}
      >
        <h3>Select Tags</h3>
        <Form {...{ selectedOptions, setSelectedOptions, errors, setErrors }} />
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={handleModalClose}
          >
            Cancel
          </button>
          <button
            type="button"
            ref={buttonRef}
            onClick={handleAddToStock}
            className="button"
          >
            Submit
          </button>
        </div>
      </CustomModal>
    </>
  );
};
